import React from 'react'
import axios from 'axios'
import Thumbnailtded from './Thumbnailtded'
import {Link} from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';

class Maintded extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            list : [],
            page : 1,
            id : null,
            from : this.props.from?this.props.from:null
        }
    }
    componentDidMount(){
        
        //axios.get(`https://tded.mvpkick.com/index.php?page=${this.state.page}`).then(res =>{
            axios.get(`https://api.mvpkick.com/tded_ai?page=${this.state.page}`).then(res =>{
                this.setState({list : res.data})
        })
    }

    selectPage = (page) =>{
        window.scrollTo(0, 0)
        //axios.get(`https://tded.mvpkick.com/index.php?page=${page}`).then(res =>{
            axios.get(`https://api.mvpkick.com/tded_ai?page=${page}`).then(res =>{
            this.setState({list : res.data, page : page})
        })
    }

    setDate = (timestamp) =>{
        let d = new Date(timestamp*1000);
        let months = ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฏาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"];
        let hour = d.getHours();
        let minutes = d.getMinutes();
        if (hour < 10) { hour = "0" + hour; }   
        if (minutes < 10) { minutes = "0" + minutes; }      

        return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`
    }

    render(){
        
        if(this.state.list.length>0){
            var dataTded = this.state.list.slice(0,8).map((item,index) =>{
                
                return(
                    <Link to={`/tded/${item.idmatch}/`} target="_blank" key={item.idmatch}>
                    <div className="listTded col-5">
                    <div style={{overflow:'hidden'}}><Thumbnailtded id={item.idmatch} /></div>
                        {/* <div className="col-12 dateTdedRow text-right"><span>{this.setDate(item.updatepost)}</span></div> */}
                    </div>
                    </Link>
                )
                
            })
        }
        return(
            this.state.list.length>0?
            this.state.from==='livescore'?
            <div className="boxTdedLs">
                {dataTded.slice(0,4)}
            </div>:
            <HelmetProvider>
                <Helmet>
                <title>วิเคราะห์บอลวันนี้ ทีเด็ดบอลวันนี้ ฟันธงบอล ทรรศนะบอลคืนนี้ โดย MVPKICK</title>
                <meta name="description" content='อ่านบทวิเคราะห์บอลรายวัน ฟันธงสกอร์แม่นๆ ทีเด็ดบอลวันนี้ บอลเต็ง บอลต่อ บอลรอง ทีมไหนน่าเข้าเล่น มาอ่านแนวทางจากทีมงาน MVPKICK.COM ที่มากประสบการณ์ในวงการลูกหนัง' />
                <link rel="canonical" href={`https://mvpkick.com/tded/`} />
                <meta property="og:url" content={`https://mvpkick.com/tded/`} />
                <meta property="og:title" content="วิเคราะห์บอลวันนี้ ทีเด็ดบอลวันนี้ ฟันธงบอล ทรรศนะบอลคืนนี้ โดย MVPKICK" />
                <meta property="og:description" content='อ่านบทวิเคราะห์บอลรายวัน ฟันธงสกอร์แม่นๆ ทีเด็ดบอลวันนี้ บอลเต็ง บอลต่อ บอลรอง ทีมไหนน่าเข้าเล่น มาอ่านแนวทางจากทีมงาน MVPKICK.COM ที่มากประสบการณ์ในวงการลูกหนัง' />
                <meta property="og:image" content="https://mvpkick.com/img/asset/og-img-main.jpg" />
                </Helmet>
            <div className="tdedPostLists text-center">
                {dataTded}
                <div>
                    <div className="col-4 btn btn-tded-news" onClick={(e) => this.selectPage(--this.state.page)} style={this.state.page===1?{pointerEvents: 'none',opacity:'0.25'}:{cursor:'pointer'}}>ก่อนหน้า</div>
                    <div className="col-2">หน้า {this.state.page}</div>
                    <div className="col-4 btn btn-tded-news" onClick={(e) => this.selectPage(++this.state.page)} style={this.state.list.length<9?{pointerEvents: 'none',opacity:'0.25'}:{cursor:'pointer'}}>ถัดไป</div>
                </div>
                <div className="boxContentPage" style={{maxWidth :'1300px'}}>
                    <div>
                        <h1>ฟันธงบอล ทรรศนะบอล ทีเด็ดบอล วิเคราะห์บอลวันนี้ ด้วยระบบเฉพาะของ MVPKICK</h1>
                        <p>เมื่อหาแหล่งวิเคราะห์บอลจากกูรูมาหลายเว็บไซต์ แต่ยังไม่โดนใจสักที่ เข้าบ้าง เสียบ้าง เงินทุนร่อยหรอจากการตามรอยบทวิจารณ์บอลจากหลายๆแหล่งมานาน ลองระบบเฉพาะของ MVPKICK.COM เว็บไซต์ที่วิเคราะห์บอลล่วงหน้าด้วยระบบ AI สูตรเฉพาะของเรา จากการนำสถิติย้อนหลังของทั้งสองมาคำนวน ข้อมูลจำนวนประตูได้เสีย ข้อมูลการเล่นเฉพาะลีก ค่าเฉลี่ยต่อเกมส์อยู่ในเกณฑ์ดีหรือแย่ และค่าสถิติอื่นๆที่สำคัญโดยเลือกเฉพาะข้อมูลที่สัมพันธ์กับทัวร์นาเม้นที่กำลังจะเกิดขึ้น เพื่อให้เกิดความสมเหตุสมผลและมีโอกาสเข้าเป้าได้มากที่สุด เพราะเราเชื่อว่า การวิเคราะห์จากสถิติที่เกิดขึ้นจริง หากนำมาคำนวนผ่านสูตรการวิเคราะห์ที่ถูกต้อง ย่อมมีโอกาสแม่นยำกว่าการวิเคราะห์จากความรู้สึกส่วนตัวของเหล่าเซียนบอล เราแจกทีเด็ดพร้อมฟันธงสกอร์ล่วงหน้า เพื่อนำไปอิงกับราคาต่อรอง Handicap, Over/Under, 1X2 ของคู่นั้นๆได้ทันที อยากรู้ว่าความแตกต่างระหว่างสูตรทีเด็ดบอลของ MVPKICK จะแตกต่างกับการวิเคราะห์บอลผ่านกูรูทั่วไปมากแค่ไหน ต้องลองด้วยตัวเอง</p>
                        <p><span style={{color:'orange'}}>"ข้อควรรู้ก่อนอิงข้อมูลทีเด็ดบอลจากระบบของเรา"</span> เนื่องจากระบบสูตรบอลนั้นอิงจากผลงานในบ้านของทีมเหย้า และนอกบ้านของทีมเยือน รวมถึงนำเฉพาะรายการทัวร์นาเม้นเดียวกันที่เกี่ยวข้องเท่านั้นมาคำนวน เพื่อให้มีความน่าจะเป็นมากที่สุด ดังนั้น สำหรับบางรายการแข่งที่จัดขึ้นในสนามกลาง (ไม่มีใครเป็นเจ้าบ้าน) ผู้อ่านจะควรใช้ดุลพินิจส่วนตัวในการ "ให้เกรด" หรือ "ตัดเกรด" เพิ่มเติม รวมถึงหากคู่ไหนมีสถิติย้อนหลังน้อยเกินไป ระบบอาจแจ้งว่าไม่สามารถคำนวนได้ ผู้อ่านที่เชื่อในหลักวิเคราะห์เชิงสถิติควรเลี่ยงคู่เหล่านั้น นอกจากนี้ การคำนวนอิงจากสถิติที่เกิดขึ้นมาแล้วย้อนหลัง หากในแมตซ์ปัจจุบันกำลังลงสนาม ระหว่างรายการแข่งมีนักเตะรายสำคัญได้รับบาดเจ็บตั้งแต่ต้นเกม อาจส่งผลให้ผลบอลไม่ใกล้เคียงกับการวิเคราะห์บอลจากทางเราได้เช่นกัน โลกของฟุตบอลไม่มีอะไรแน่นอน 100% แต่มั่นใจว่าบทวิเคราะห์บอล <Link to='/tded/'>ทีเด็ดบอล</Link> ฟันธงบอลวันนี้ จาก MVPKICK.COM จะช่วยเพิ่มโอกาสการทำนายผลบอลล่วงหน้าของแฟนๆลูกหนัง ให้เข้าเป้ามากยิ่งขึ้นได้แน่นอน</p>
                    </div>
                </div>
            </div>
            </HelmetProvider>:
            <div className="listMatch text-center">No Data</div>
        )
    }
}

export default Maintded; 